import call from "./call";
import {
  ChatData,
  ChatHistory,
  Generate,
  SingleChat,
  CompletionsRequest,
  CompletionsResponse,
  Ability,
  AbilitiesResponse,
  PaginatedChatsResponse,
  ChatUpdatePayload,
} from "../Models/chatUI";

export const getAllChats = async (): Promise<ChatHistory[]> => {
  const response = await call.get<PaginatedChatsResponse>("/v1/chat/", {
    snack: {
      error: "chat.fetchError",
    },
  });
  return response.data.chats;
};

export const getSingleChat = async (chatId: string): Promise<SingleChat> => {
  const response = await call.get<SingleChat>(`/v1/chat/${chatId}/`, {
    snack: {
      error: "chat.fetchSingleError",
    },
  });
  return response.data;
};

export const updateChat = async (
  chatId: string,
  chatData: ChatUpdatePayload
): Promise<ChatUpdatePayload> => {
  const response = await call.put<ChatUpdatePayload>(
    `/v1/chat/${chatId}/`,
    chatData,
    {
      snack: {
        error: "chat.updateError",
      },
    }
  );
  return response.data;
};

export const createChat = async (chatData: ChatData): Promise<ChatData> => {
  const response = await call.post<ChatData>("/v1/chat/", chatData, {
    snack: {
      error: "chat.createError",
    },
  });
  return response.data;
};

export const deleteChat = async (chatId: string) => {
  const response = await call.delete(`/v1/chat/${chatId}/`, {
    snack: {
      success: "chat.deleteSuccess",
      error: "chat.deleteError",
    },
  });
  return response;
};

export const generate = async (chatId: string, generateMessage: Generate) => {
  const response = await call.post<Generate>(
    `/v1/chat/${chatId}/generate`,
    generateMessage,
    {
      snack: {
        error: "chat.generateError",
      },
    }
  );
  return response.data;
};

export const completions = async (
  request: CompletionsRequest
): Promise<CompletionsResponse> => {
  const response = await call.post<CompletionsResponse>(
    "/v1/llm/completions",
    request,
    {
      snack: {
        error: "chat.generateError",
      },
    }
  );
  return response.data;
};

export const getAllAbilities = async (): Promise<Ability[]> => {
  const response = await call.get<AbilitiesResponse>("/v1/chat/abilities/", {
    snack: {
      error: "chat.fetchAbilitiesError",
    },
  });
  return response.data.abilities;
};
